import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import ProductLabelComponent from './product-label.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [ProductLabelComponent, ProductLabelComponent, ProductLabelComponent],
  declarations: [ProductLabelComponent, ProductLabelComponent, ProductLabelComponent],
})
export class ProductLabelModule { }
